import type { MenuItemLink } from '@/modules/Menu';

export const footerMenu: MenuItemLink[] = [
  {
    name: {
      cs: 'Kontakt',
      sk: 'Kontakt',
    },
    url: {
      name: 'cruisesContact',
    },
  },
  {
    name: {
      cs: 'Dovolená na jachtě',
      sk: 'Dovolená na jachtě',
    },
    url: {
      name: 'cruisesYacht',
    },
  },
  {
    name: {
      cs: 'Obchodní podmínky',
      sk: 'Obchodní podmínky',
    },
    url: {
      name: 'contentPage',
      params: {
        contentPageName: 'obchodni-podminky',
      },
    },
  },
  {
    name: {
      cs: 'Kde nás najdete',
      sk: 'Kde nás najdete',
    },
    url: '/yachtas-coffee/',
  },
  {
    name: {
      cs: 'GDPR',
      sk: 'GDPR',
    },
    url: {
      name: 'contentPage',
      params: {
        contentPageName: 'gdpr',
      },
    },
  },
];
